import { createBrowserRouter, createRoutesFromElements, Route, useRouteError } from 'react-router-dom';
import { Layout } from '$Components/layout/Layout';

import { React, s } from 'Imports';

import RequiredAgreements from '$Pages/Agreements/RequiredAgreements';
import { RequiredAuth } from '../oauth/RequiredAuth';

import { StandardProtectedRoutes, StandardPublicRoutes } from './route-sets/StandardRoutes';
import { GeoTabIntegratedRoutes } from './route-sets/GeoTabIntegratedRoutes';
import { IConfigServiceInjectedProps } from '$State/ConfigFreezerService';

const ErrorBoundary = () => {
    const error = useRouteError();
    console.error('Router error:', error);

    return (
        <div role="alert">
            <h2>Oops! Something went wrong</h2>
            <p>There was an error loading this page.</p>
        </div>
    );
};

export type RouterProps = IConfigServiceInjectedProps;

export const createAppRouter = (props: RouterProps) => {
    return createBrowserRouter(
        createRoutesFromElements(
            <>
                <Route element={<Layout />} errorElement={<ErrorBoundary />}>
                    <Route errorElement={<ErrorBoundary />}>{!props.config.isRunningGeotabIntegrated() && StandardPublicRoutes()}</Route>
                    <Route element={<RequiredAuth />}>
                        <Route element={<RequiredAgreements />}>
                            {props.config.isRunningGeotabIntegrated() ? GeoTabIntegratedRoutes() : StandardProtectedRoutes()}
                        </Route>
                    </Route>
                </Route>
            </>,
        ),
    );
};
